import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-up-tail",
  "use": "icon-arrow-up-tail-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-up-tail\">\n  <defs></defs>\n  <path d=\"M 10.749 3.509 L 10.749 18.483 C 10.749 18.684 10.678 18.854 10.537 18.994 C 10.395 19.137 10.216 19.208 10.001 19.208 C 9.786 19.208 9.607 19.137 9.464 18.994 C 9.324 18.854 9.253 18.684 9.253 18.483 L 9.253 3.509 L 3.772 9.34 C 3.638 9.49 3.463 9.564 3.248 9.564 C 3.031 9.564 2.854 9.484 2.712 9.327 C 2.571 9.168 2.5 8.982 2.5 8.767 C 2.5 8.55 2.575 8.359 2.724 8.193 L 9.477 1.017 C 9.61 0.868 9.785 0.793 10 0.793 C 10.215 0.793 10.39 0.868 10.523 1.017 L 17.276 8.193 C 17.425 8.359 17.5 8.55 17.5 8.767 C 17.5 8.982 17.429 9.168 17.288 9.327 C 17.146 9.484 16.973 9.564 16.765 9.564 C 16.557 9.564 16.378 9.49 16.228 9.34 L 10.749 3.509 Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/arrow-up-tail.svg
// module id = 9Kb9
// module chunks = 258